import React from 'react'

import AchievementWidgetSkeleton from './AchievementWidgetSkeleton'
import AchievementWidgetHeaderPlaceholder from './subcomponents/AchievementWidgetHeader/AchievementWidgetPlaceholder'
import AchievementWidgetBodyPlaceholder from './subcomponents/AchievementWidgetBody/AchievementWidgetBodyPlaceholder'
import AchievementWidgetFooterPlaceholder from './subcomponents/AchievementWidgetFooter/AchievementWidgetFooterPlaceholder'

const LiveLessonWidgetPlaceholder = () => {
  return (
    <AchievementWidgetSkeleton
      headerSection={<AchievementWidgetHeaderPlaceholder />}
      bodySection={<AchievementWidgetBodyPlaceholder />}
      footerSection={<AchievementWidgetFooterPlaceholder />}
    />
  )
}

export default LiveLessonWidgetPlaceholder
